<template>

  <Tabs id="taskDetailEditTabPanel" type="card" v-model="defaultProject" v-if="showTabs.length > 0">
    <TabPane label="体检项目" name="physicalProject" v-if="showTabs.indexOf('physicalProject') > -1" :disabled="!medicalType?false:(medicalType&&medicalType===2)">

      <el-input placeholder="输入关键字进行过滤" v-model="filterProjectText" clearable style="width: 50%;margin-bottom: 3px;"/>
      <FormItem :label-width="0" :style="{'max-height': maxHeight, 'overflow-y': 'auto'}">
        <el-tree ref="projectTree" class="treeBox" :data="projectsTreeData"
                show-checkbox :check-strictly="true" node-key="id" :filter-node-method="filterNode"
                 :highlight-current="true" :expand-on-click-node="false" @check-change="projectIdsCheck">

            <span class="custom-tree-node" slot-scope="{ node, data }">
                <div class="custom-tree-node-content">{{ node.label }}
                  <span :style="{'color': convertBusinessType(data.businessType).color}" v-if="data.businessType">--{{ convertBusinessType(data.businessType).name }}</span>
                </div>

                <div class="custom-tree-node-content" v-if="model ==='table' ">
                  <span >
                    <el-select :value="data.projectType" placeholder="请选择项目类型" :disabled="true"
                               clearable  placement="top" transfer size="mini" style="width: 90px;" @change="(val)=>{handleProjectsTreeDataChange('projectType',data,val)}">
                      <el-option v-for="item in lisProjectTypes"
                                 :key="item.id" :value="item.value" :label="item.label"
                                 style="width:90px;z-index: 9999;"/>
                    </el-select>
                  </span>
                  <span >
                    价格:
                    <Input type="text" placeholder="请输入价格" style="width:60px;"
                           v-model="data.price" @on-keyup="changeinput(data,'price', data.price)"
                           @input="(val)=>{handleLisProjectsTreeDataChange('price',data,val)}" :disabled="true"/>
                  </span>
                </div>
            </span>
        </el-tree>
      </FormItem>
    </TabPane>

    <TabPane label="Lis项目" name="lisProject" v-if="showTabs.indexOf('lisProject') > -1" :style="{'max-height': '450px', 'overflow-y': 'auto'}" :disabled="!medicalType?false:(medicalType&&medicalType===1)">

      <el-input placeholder="输入关键字进行过滤" v-model="filterLisProjectText" clearable style="width: 50%;margin-bottom: 3px;"/>
      <FormItem :label-width="0" :style="{'max-height': maxHeight, 'overflow-y': 'auto'}">
        <el-tree ref="lisProjectTree" :data="lisProjectsTreeData"
            show-checkbox :check-strictly="true" node-key="id" :filter-node-method="filterNode" :highlight-current="true"
            @check-change="lisProjectIdsCheck" :expand-on-click-node="false">
          <span class="custom-tree-node" slot-scope="{ node, data }">
              <el-tooltip class="item" effect="dark" :content="node.label" placement="top-start">
                <div class="custom-tree-node-content" style="max-width: 400px;word-break: break-all;white-space: nowrap;overflow:hidden;text-overflow:ellipsis;">{{ node.label }}
                  <span :style="{'color': convertBloodTube(data.bloodTubeId).color}" v-if="data.bloodTubeId">-{{data.bloodTubeName}}</span>
                </div>
              </el-tooltip>
              <div class="custom-tree-node-content" v-if="model ==='table' && data.showCheckbox !== false">
                <span>
                  <el-select :value="data.projectType" placeholder="请选择项目类型" clearable  placement="top" transfer size="mini" style="width: 90px;"
                             @change="(val)=>{handleLisProjectsTreeDataChange('projectType', data, val, true)}" :disabled="true">
                    <el-option v-for="item in lisProjectTypes" :key="item.id" :value="item.value" :label="item.label"  style="width:90px;z-index: 9999;"/>
                  </el-select>
                </span>
                <span>
                  价格:
                   <Input type="text" placeholder="请输入价格" style="width:50px;"
                          v-model="data.price" @on-keyup="changeinput(data,'price', data.price)"
                          @input="(val)=>{handleLisProjectsTreeDataChange('price', data, val, true)}" :disabled="true"/>
                </span>
              </div>
            </span>
        </el-tree>
      </FormItem>
    </TabPane>
  </Tabs>
</template>
<script>
import {mixins} from "@/mixins";

export default {
  name: "TaskDetailEditTabPanel",
  mixins: [mixins],
  data() {
    return {
      lisProjectTypes:[
        {label: '默认项目', value: 1},
        {label: '自费项目', value: 2},
        {label: '加做项目', value: 3},
      ],
      filterProjectText:"",
      filterLisProjectText:"",
      defaultProject: '',
      loading:false,
      defaultProps: {
        children: 'children',
        label: 'label',
      },
      projectsTreeData:[],
      lisProjectsTreeData:[],
    }
  },
  props: {
    model: {
      type: String,
      default: () => {
        return 'simple';
      }
    },
    disabled:{
      type: Boolean,
      default: () => {
        return false;
      }
    },
    packagesId: {
      type: String,
      default: () => {
        return '';
      }
    },
    showTabs: {
      type: Array,
      default: () => {
        return ['physicalProject', 'lisProject'];
      }
    },
    taskProjects: {
      type: Array,
      default: () => {
        return [];
      }
    },
    taskLisProjects: {
      type: Array,
      default: () => {
        return [];
      }
    },
    projectIds: {
      type: Array,
      default: () => {
        return [];
      }
    },
    lisProjectIds: {
      type: Array,
      default: () => {
        return [];
      }
    },
    medicalType: {
      default: () => {
        return null;
      }
    },
    localApplicableAgeList:{
      type:Array,
      default:()=>{
        return [];
      }
    },
    maxHeight: {
      type: String,
      default: () => {
        return '280px';
      }
    },
  },
  watch: {
    filterProjectText(val) {
      this.$refs.projectTree.filter(val);
    },
    filterLisProjectText(val) {
      this.$refs.lisProjectTree.filter(val);
    },
    taskProjects: {
      handler(newVal, oldVal) {
        if (newVal && newVal.length > 0){
          this.loadProjectsTree(newVal);
        }
      }
    },
    taskLisProjects: {
      handler(newVal, oldVal) {
        if (newVal && newVal.length > 0){
          this.loadLisProjectsTree(newVal);
        }
      }
    },
    projectIds:{
      handler(newVal){
        if (newVal && newVal.length > 0){
          this.$refs.projectTree.setCheckedKeys(newVal);
        }else {
          this.$refs.projectTree.setCheckedKeys([]);
        }
      }
    },
    lisProjectIds:{
      handler(newVal){
        if (newVal && newVal.length > 0){
          this.$refs.lisProjectTree.setCheckedKeys(newVal);
        }else {
          this.$refs.lisProjectTree.setCheckedKeys([]);
        }
      }
    },
    medicalType:{
      handler(newVal){
        if (newVal && newVal === 1){
          this.defaultProject = "physicalProject";
        }else if (newVal && newVal === 2){
          this.defaultProject = "lisProject";
        }
      }
    }
  },
  mounted() {
    this.initProjects();
    this.initLisProjects();
    this.$forceUpdate()
  },
  methods: {
    convertBusinessType(businessType){
      if(businessType === 1){
        return {color:'#16B94E',name:"通用"};
      }else if(businessType === 2){
        return {color:'#BDAE0C',name:"幼儿园"};
      }else if(businessType === 3){
        return {color:'#BF7007',name:"小学"}
      }else if(businessType === 4){
        return {color:'#006DFD',name:"中学"}
      }else if(businessType === 5){
        return {color:'#CE1616',name:"大学"};
      }
    },
    convertBloodTube(bloodTubeId){
      if(bloodTubeId === 1){
        return {color:'#CE1616',name:"红管"};
      }else if(bloodTubeId === 2){
        return {color:'#16B94E',name:"绿管"};
      }else if(bloodTubeId === 3){
        return {color:'#540BA2',name:"紫管"}
      }else if(bloodTubeId === 4){
        return {color:'#006DFD',name:"蓝管"}
      }else if(bloodTubeId === 5){
        return {color:'#100F0FFF',name:"黑管"};
      }else if(bloodTubeId === 6){
        return {color:'#BDAE0C',name:"黄管"}
      }else if(bloodTubeId === 7){
        return {color:'#9BA0AB',name:"灰管"}
      }else if(bloodTubeId === 8){
        return {color:'#BF7007',name:"橙管"}
      }else if(bloodTubeId === 9){
        return {color:'#CE1616',name:"红管"};
      }else if(bloodTubeId === 10){
        return {color:'#CE1616',name:"红管"};
      }
    },
    filterNode(value, data) {
      if (!value) return true;
      return data.label.indexOf(value) !== -1;
    },
    //####################处理体检项目######################start
    projectIdsCheck(){
      let ids = this.$refs.projectTree.getCheckedKeys();
      this.$emit("update:projectIds",ids);
      if (this.$props.model === 'table'){
        this.handleProjectsTreeDataChange()
      }
    },
    initProjects() {
      this.loading=true;
      let projectIds = this.loadProjectsTree(this.$props.taskProjects);
      this.loading=false;
      this.$nextTick(()=>{
        if (this.$props.model==='table'){
          this.handleProjectsTreeDataChange();
          this.$emit("update:projectIds",projectIds);
        }else{
          this.$refs.projectTree.setCheckedKeys(this.$props.projectIds);
        }
      })
    },
    loadProjectsTree(taskProjects) {
      this.loading=true;
      let tempList=[]
      let projectIds = [];

      if(taskProjects&&taskProjects.length>0){
        taskProjects.forEach(item => {
          if (item.status && item.status === 2){
            projectIds.push(item.projectId)
          }

          tempList.push({
            id: item.projectId,
            pid: item.parentId,
            // label: item.projectName + (item.businessType ? (item.businessType == 1 ? '-通用' : item.businessType == 2 ? '-幼儿园' : item.businessType == 3 ? '-小学' : item.businessType == 4 ? '-中学' :  item.businessType == 5 ? '-大学' : '') : ''),
            label: item.projectName,
            value:item.projectId,
            appShow: item.appShow,
            startApplicableAgeId: item.startApplicableAgeId,
            endApplicableAgeId: item.endApplicableAgeId,
            status: item.status,
            projectType: item.projectType,
            projectId: item.projectId,
            projectName: item.projectName,
            businessType: item.businessType,
            disabled: (item.projectType&&item.projectType===1)||this.disabled||item.disabled,
            price: item.price ? item.price : "0.00",
          })
        });
      }

      this.projectsTreeData = tempList;
      return projectIds;
    },
    //修改参数值,并重新组装参数,把值通过事件传出去
    handleProjectsTreeDataChange(paramName, data, val){
      let resultData = []
      let ids = this.$refs.projectTree.getCheckedKeys();
      for (let index = 0; index < this.projectsTreeData.length; index++) {
        let item = this.projectsTreeData[index]
        if (paramName && data){
          if (item.value === data.value){
            this.projectsTreeData[index][paramName] = val;
          }
        }
        resultData.push({
          appShow: this.projectsTreeData[index].appShow,
          startApplicableAgeId: this.projectsTreeData[index].startApplicableAgeId,
          endApplicableAgeId: this.projectsTreeData[index].endApplicableAgeId,
          price: this.projectsTreeData[index].price,
          projectId: this.projectsTreeData[index].id,
          projectName: this.projectsTreeData[index].label,
          projectType: this.projectsTreeData[index].projectType,
          businessType: this.projectsTreeData[index].businessType,
          status: ids.indexOf(this.projectsTreeData[index].id) > -1 ? 2 :1,
          disabled: this.projectsTreeData[index].disabled
        })
      }
      this.$emit("setTaskProjects", this.packagesId, "taskProjects", resultData)
    },
    //####################处理体检项目######################end

    //####################处理lis项目######################start
    lisProjectIdsCheck(){
      let ids = this.$refs.lisProjectTree.getCheckedKeys();
      this.$emit("update:lisProjectIds",ids);
      if (this.$props.model === 'table'){
        this.handleLisProjectsTreeDataChange(null ,null, null, true)
      }
    },
    initLisProjects() {
      this.loading=true;
      let lisProjectIds = this.loadLisProjectsTree(this.$props.taskLisProjects);
      this.loading=false;
      this.$nextTick(()=>{
        if (this.$props.model==='table'){
          this.handleLisProjectsTreeDataChange(null ,null, null, false)
          this.$emit("update:lisProjectIds",lisProjectIds);
        }else {
          this.$refs.lisProjectTree.setCheckedKeys(this.$props.lisProjectIds);
        }
      })
    },
    loadLisProjectsTree(taskLisProjects){
      let tempList=[]
      let lisProjectIds = [];

      if(taskLisProjects&&taskLisProjects.length>0){
        taskLisProjects.forEach(item => {
          if (item.status && item.status == 2){
            lisProjectIds.push(item.lisProjectId)
          }
          let children = [];
          if (item.children) {
            item.children.forEach(subItem => {
              children.push({
                id: subItem.optionsId,
                value:subItem.optionsId,
                label: subItem.name,
                pid: subItem.parentId,
                name: subItem.name,
                price: "0.00",
                disabled:true,
                showCheckbox: false,
              })
            })
          }

          tempList.push({
            id: item.lisProjectId,
            value:item.lisProjectId,
            pid: item.parentId,
            label: item.lisProjectName + "(" + item.lisProjectCode + ")",
            children: children,
            status: item.status,
            projectType: item.projectType,
            price: item.price ? item.price : "0.00",
            lisProjectName: item.lisProjectName,
            lisProjectCode: item.lisProjectCode,
            bloodTubeId: item.bloodTubeId,
            bloodTubeName: item.bloodTubeName,
            disabled: (item.projectType&&item.projectType==1)||this.disabled||item.disabled,
            lisProjectId: item.lisProjectId
          })
        })
      }
      this.lisProjectsTreeData = tempList;
      return lisProjectIds;
    },
    //修改参数值,并重新组装参数,把值通过事件传出去
    handleLisProjectsTreeDataChange(paramName, data, val, refresh){
      let resultData=[]
      let ids = this.$refs.lisProjectTree.getCheckedKeys();
      for (let index = 0; index < this.lisProjectsTreeData.length; index++) {
        let item = this.lisProjectsTreeData[index]
        if (paramName && data){
          if (item.value === data.value){
            this.lisProjectsTreeData[index][paramName] = val;
          }
        }

        resultData.push({
          lisProjectId: this.lisProjectsTreeData[index].lisProjectId,
          lisProjectName: this.lisProjectsTreeData[index].lisProjectName,
          lisProjectCode: this.lisProjectsTreeData[index].lisProjectCode,
          bloodTubeId: this.lisProjectsTreeData[index].bloodTubeId,
          bloodTubeName: this.lisProjectsTreeData[index].bloodTubeName,
          price: this.lisProjectsTreeData[index].price,
          projectType: this.lisProjectsTreeData[index].projectType,
          status: ids.indexOf(this.lisProjectsTreeData[index].lisProjectId) > -1 ? 2 : 1,
          disabled: this.lisProjectsTreeData[index].disabled,
          children: this.lisProjectsTreeData[index].children,
        })
      }
      this.$emit("setTaskProjects", this.$props.packagesId, "taskLisProjects", resultData, refresh)
    },
    //####################处理lis项目######################end
  },
  changeinput(data, fieldName, value){
    if(!value){
      return;
    }
    data[fieldName] = value
    data[fieldName] = data[fieldName].replace(/[^\d.]/g, '');
    data[fieldName] = data[fieldName].replace(/^\./g, '');
    data[fieldName] = data[fieldName].replace(/\.{2,}/g, '');
    data[fieldName] = data[fieldName].replace('.', '$#$').replace(/\./g, '').replace('$#$', '.');

    if (data[fieldName].indexOf('.') !== -1 && data[fieldName].length > 10) {
      data[fieldName] = data[fieldName].substring(0,10);
    }

    let count = -1
    for (let i in data[fieldName]) {
      if (data[fieldName][i] === '.') {
        count = i
      }
      if (count !== -1) {
        if ((i - count) > 2) {
          data[fieldName] = data[fieldName].substring(0, data[fieldName].length - 1)
        }
      }
    }
  },
};
</script>
<style lang="postcss">
#editTabPanel {min-height: 300px;}
.treeBox{min-width: 600px;overflow-x: auto;overflow-y: hidden;}
.custom-tree-node {flex: 1;display: flex;align-items: center;justify-content: space-between;font-size: 14px;}
.custom-tree-node .custom-tree-node-content{justify-content: space-between;}
.custom-tree-node .custom-tree-node-content span{margin-left: 3px;}
.disable-area{pointer-events: none;opacity: 0.7;}
.el-tree-node{margin: 13px 0}
</style>
